import { SwitchButton } from "components/switchButton";
import { Link } from "react-router-dom";
import Button from "components/button";
import { EyeIcon, PencilIcon } from "@heroicons/react/outline";
import moment from "moment";
import { IAdminAccountItem } from "interfaces";
import { isHaveActionPermission } from "utills/helpers";

interface AdminAccountTableProps {
  data?: IAdminAccountItem[];
  pageSize: number;
  currentPage: number;
  _toggleActive: (id: string, isActive: boolean) => void;
}

export const AdminAccountTable = ({
  data = [],
  pageSize = 10,
  currentPage = 1,
  _toggleActive,
}: AdminAccountTableProps) => {
  return (
    <div className="flow-root">
      <div className="relative inline-block w-full align-middle box-border">
        <table className="w-full divide-y divide-gray-300 bg-magnolia-500 rounded-md">
          <thead>
            <tr>
              <th scope="col" className="th py-3.5 pl-4 pr-3 sm:pl-6 lg:pl-8">
                No
              </th>
              <th scope="col" className="th">
                Full Name
              </th>
              <th scope="col" className="th">
                Email
              </th>
              <th scope="col" className="th">
                Role
              </th>
              <th scope="col" className="th">
                Created at/by
              </th>
              <th scope="col" className="th">
                Status
              </th>
              <th scope="col" className="th w-28">
                <span className="sr-only">Action</span>
                <p className="">Action</p>
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200 bg-white">
            {data.map((item: IAdminAccountItem, index: number) => (
              <tr key={index}>
                <td className="td py-4 pl-4 pr-3 sm:pl-6 lg:pl-8">
                  {(currentPage - 1) * pageSize + 1 + index}
                </td>
                <td className="td">
                  {item.first_name} {item.last_name}
                </td>
                <td className="td">
                  {item.email}
                </td>
                <td className="td">
                  {item.role_name}
                </td>
                <td className="td">
                  <p>{item.created ? moment(item.created).format("DD/MM/YYYY HH:mm:ss") : ""}</p>
                  <p>{item.created_by}</p>
                </td>
                <td className="td">
                  <SwitchButton
                    checked={item.is_active}
                    disabled={!isHaveActionPermission("account", "admin", "edit")}
                    onChange={() => _toggleActive(item.id, !item.is_active)}
                  />
                </td>
                <td className="td py-4 pl-3 pr-4 sm:pr-6 lg:pr-8">
                  <div className="flex justify-start items-end gap-x-2 ">
                    <Link to={`/admin-accounts/accounts/${item.id}`} className="w-fit">
                      <Button className="w-8 h-8 bg-gray-200 hover:bg-gray-100 active:bg-gray-300">
                        <EyeIcon className="w-4 h-4 text-black" />
                      </Button>
                    </Link>
                    {isHaveActionPermission("account", "admin", "edit") ? (
                      <Link
                        to={`/admin-accounts/accounts/${item.id}/edit`}
                        className="w-fit"
                      >
                        <Button className="w-8 h-8 bg-gray-200 hover:bg-gray-100 active:bg-gray-300">
                          <PencilIcon className="w-4 h-4 text-black" />
                        </Button>
                      </Link>
                    ) : (
                      <></>
                    )}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
